import { getSupabaseClient } from './Supa';
import { currentUser$ } from './Firebase';
import { Tables } from './database.types';

export async function getUserProfile(): Promise<Tables<'users'> | null> {
  const user = currentUser$.get();
  if (!user) return null;

  const supabase = getSupabaseClient();
  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('id', user.uid)
    .maybeSingle();

  if (error) {
    console.error('[userHelpers] getUserProfile error:', error);
    return null;
  }

  return data;
}

export async function upsertUserProfile(
  profile: Partial<Tables<'users'>>
): Promise<Tables<'users'> | null> {
  const user = currentUser$.get();
  if (!user) return null;

  const supabase = getSupabaseClient();
  const { data, error } = await supabase
    .from('users')
    .upsert({ id: user.uid, ...profile })
    .select()
    .single();

  if (error) {
    console.error('[userHelpers] upsertUserProfile error:', error);
    return null;
  }

  return data;
}
